import React from 'react';
import { ActionButton } from '@adobe/react-spectrum';
import { useDispatch, useSelector } from 'react-redux';
import { getAnalytics, logEvent } from 'firebase/analytics';
import Settings from '@spectrum-icons/workflow/Settings';
import ViewList from '@spectrum-icons/workflow/ViewList';
import Link from '@spectrum-icons/workflow/Link';
import { setAppRoute } from '../../../data/redux/slices/appSlice';
import { BreadCrumbActionBar } from '../BreadCrumbActionBar';

const NAV_ITEMS = [
    { route: '/settings', label: 'Settings', Icon: Settings },
    { route: '/managedecks', label: 'Decks', Icon: ViewList },
    { route: '/linkedaccounts', label: 'Accounts', Icon: Link },
];

export function BreadCrumbProfileNavBar() {
    const dispatch = useDispatch();
    const appRoute = useSelector((state) => state?.app?.route);
    const currentPath =
        appRoute?.path && appRoute.path !== '' ? appRoute.path : window.location.pathname;

    return (
        <BreadCrumbActionBar maxVisibleMobile={2}>
            {NAV_ITEMS.map(({ route, label, Icon }) => {
                const isActive = currentPath === route;
                return (
                    <ActionButton
                        key={route}
                        isDisabled={isActive}
                        aria-label={label}
                        aria-current={isActive ? 'page' : undefined}
                        UNSAFE_className={`bcProfileNavBtn${isActive ? ' is-active' : ''}`}
                        onPress={() => {
                            logEvent(getAnalytics(), `bc_profile_nav_${route}`);
                            dispatch(setAppRoute({ route }));
                        }}
                    >
                        <span className="bcBtnLabel">{label}</span>
                        <Icon />
                    </ActionButton>
                );
            })}
        </BreadCrumbActionBar>
    );
}
